import { useState } from 'react'
import NestedContentComponent from '../NestedContentComponent'
import EngineerDetailedInfoComponent from './EngineerDetailedInfoComponent'
import EngineersListItemRowComponent from './EngineerListItemRowComponent'

interface EngineersListItemProps {
  engineer: {
    name: string
    location: string
    phoneNumber: string
    email: string
    projects: string[]
  }
}

const EngineersListItemComponent: React.FC<EngineersListItemProps> = ({
  engineer,
}) => {
  const [showDetailedInfo, setShowDetailedInfo] = useState<boolean>(true)

  const onOpenDetailedInfo = () => {
    setShowDetailedInfo(true)
  }

  const onCloseDetailedInfo = () => {
    setShowDetailedInfo(false)
  }

  return (
    <NestedContentComponent
      title={
        <EngineersListItemRowComponent
          engineer={engineer}
          showDetailedInfo={showDetailedInfo}
        />
      }
      arrowColor='#56003D'
      arrowOpenColor='#fff'
      arrowOutlined={true}
      openBackgroundColor='#56003D'
      onOpen={onOpenDetailedInfo}
      onClose={onCloseDetailedInfo}
    >
      <EngineerDetailedInfoComponent engineer={engineer} />
    </NestedContentComponent>
  )
}

export default EngineersListItemComponent
